<template>
  <div
    class="row"
  >
    <q-select
      v-model="selectedColorName"
      class="col"
      :options="colorOptions"
      map-options
      emit-value
      clearable
      :disable="disable"
      :label="label"
    >
      <q-tooltip v-if="!!tooltip">
        {{ tooltip }}
      </q-tooltip>
    </q-select>
    <div class="col q-ml-md">
      <color-picker
        :color-name="selectedColorName"
        :color-hex="selectedColorHex"
        :disable="disable"
        @update:model-value="handleCustomColorHex"
      />
    </div>
  </div>
</template>

<script>
import { colorOptions } from 'src/models/page/Section'
import ColorPicker from 'src/modules/admin/components/ColorPicker'

export default {
  name: 'ColorSelection',
  components: {
    ColorPicker
  },
  props: {
    colorName: {
      type: String,
      required: false,
      default: null
    },
    customColorHex: {
      type: String,
      required: false,
      default: null
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: 'Color'
    },
    tooltip: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      selectedColorName: this.colorName,
      selectedColorHex: this.customColorHex
    }
  },
  watch: {
    selectedColorName () {
      this.$emit('update:model-value', this.selectedColorName, this.selectedColorHex)
    },
    selectedColorHex () {
      this.$emit('update:model-value', this.selectedColorName, this.selectedColorHex)
    }
  },
  created () {
    _.extend(this, { colorOptions })
  },
  methods: {
    handleCustomColorHex (colorHex) {
      this.selectedColorHex = colorHex
    }
  }
}
</script>
